/**
 * Online API
 * # Summary Elisa B2B Online API written in golang hosted in AWS cloud  # Usage This API is used in the `https://yrityksille.elisa.fi/` pages.  # Identifiers 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrderItem } from './orderItem.js';
import { DeliveryAddress } from './deliveryAddress.js';
import { DeliveryType } from './deliveryType.js';


export interface Order { 
    /**
     * Order id, normalized from onlineRequestId. Online_Order__c.Online_Order_ID__c
     */
    orderId: string;
    /**
     * Id that\'s used to identify sent shopping-cart, that\'s marked as bought
     */
    shoppingCartId: string;
    /**
     * Reference number associated to card payment of this order. When present, invoice related field i.e. billingAccountId and personBillingAccountId will be absent. SFDC: Online_Order__c.Card_Payment_Reference_Number__c
     */
    cardPaymentReferenceNumber?: string;
    /**
     * Internal, unique id of the billing account. absent in case of card payment. SFDC: Online_Order__c.BA_Number__c.
     */
    billingAccountId?: string;
    /**
     * Ordering contact person\'s SFDC internal Id. SFDC: Online_Order__c.Contact_Id__c.
     */
    contactId: string;
    /**
     * Id of the ordering Account, i.e. Y-tunnus. SFDC: set found Account to Online_Order__c.Business_Id__c.
     */
    businessId: string;
    /**
     * MDM Id of the ordering Account. SFDC: set found Account to Online_Order__c.Account_Master_MDM_Id__c.
     */
    accountMasterId: string;
    /**
     * Total one-time charge for the sent order in cents, excluding delivery. SFDC: Online_Order__c.Json_Payload__c.
     */
    totalOneTimeCharge: number;
    /**
     * Total charge in cents for sent order items with fixed term contract = sum of (quantity * recurring charge * payments) for all order items with fixed term contract. SFDC: Online_Order__c.Json_Payload__c.
     */
    totalFixedTermCharge: number;
    /**
     * Total monthly recurring charge for the order in cents. SFDC: Online_Order__c.Json_Payload__c. This field documents the total monthly infinitely recurring charges of the first monthly payment.
     */
    totalMonthlyRecurringCharge: number;
    /**
     * Total monthly recurring charge for the subscriptions (category SELF_SERVICE) in cents. SFDC: Online_Order__c.Json_Payload__c.
     */
    totalSubscriptionMonthlyRecurringCharge?: number;
    /**
     * Total one-time charge for the subscriptions (category SELF_SERVICE) in cents, mainly opening fees. SFDC: Online_Order__c.Json_Payload__c.
     */
    totalSubscriptionOneTimeCharge?: number;
    /**
     * Total monthly recurring charge for the SALES_PRODUCTS in cents. SFDC: Online_Order__c.Json_Payload__c.
     */
    totalSalesProductsMonthlyRecurringCharge?: number;
    /**
     * Total one-time charge for SALES_PRODUCTS in cents, mainly opening fees. SFDC: Online_Order__c.Json_Payload__c.
     */
    totalSalesProductsOneTimeCharge?: number;
    /**
     * Total delivery charge in cents. SFDC: Online_Order__c.Json_Payload__c.
     */
    deliveryCharge: number;
    /**
     * Alphanumeric code used to apply a promotional discount or special offer. Optional field, only present if a voucher has been applied.
     */
    voucherCode?: string;
    /**
     * Type of payment used for the order. SFDC: Online_Order__c.Json_Payload__c.
     */
    paymentType: Order.PaymentTypeEnum;
    deliveryAddress?: DeliveryAddress;
    deliveryType: DeliveryType;
    /**
     * Whether user has selected total or partial delivery of items in the order. SFDC: Online_Order__c.Shipment_Type__c
     */
    shipmentType?: Order.ShipmentTypeEnum;
    orderItems: Array<OrderItem>;
}
export namespace Order {
    export type PaymentTypeEnum = 'BILLING_ACCOUNT' | 'CARD';
    export const PaymentTypeEnum = {
        BILLING_ACCOUNT: 'BILLING_ACCOUNT' as PaymentTypeEnum,
        CARD: 'CARD' as PaymentTypeEnum
    };
    export type ShipmentTypeEnum = 'TOTAL_DELIVERY' | 'PARTIAL_DELIVERY';
    export const ShipmentTypeEnum = {
        TOTAL_DELIVERY: 'TOTAL_DELIVERY' as ShipmentTypeEnum,
        PARTIAL_DELIVERY: 'PARTIAL_DELIVERY' as ShipmentTypeEnum
    };
}


